export abstract class BaseEvent {
  eventName!: string;

  protected constructor(name: string) {
    this.eventName = name;
  }
}
